import { Component, ViewChild, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AccountDetailsTabComponent } from "./tabs/account-details-tab/account-details-tab.component";
import { AddContractsTabComponent } from "./tabs/add-contracts-tab/add-contracts-tab.component";
import { ResetQuestionTabComponent } from "./tabs/reset-question-tab/reset-question-tab.component";
import { ChangePasswordTabComponent } from "./tabs/change-password--tab/change-password-tab.component";
import { DeleteComponent } from "./tabs/delete/delete.component";
import { InviteUsersTabComponent } from "./tabs/invite-users-tab/invite-users-tab.component";

type AccountTab = "details" | "contracts" | "invite-users" | "reset-question" | "password" | "delete";

@Component({
  standalone: false,
  selector: "app-account",
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.scss"],
})
export class AccountComponent implements OnInit {
  activetab = 1;
  @ViewChild("accountDetailsTab", { static: false })
  accountDetailsTab: AccountDetailsTabComponent;
  @ViewChild("addContractsTab", { static: false })
  addContractsTab: AddContractsTabComponent;
  @ViewChild("inviteUsersTab", { static: false })
  inviteUsersTab: InviteUsersTabComponent;
  @ViewChild("resetQuestionTab", { static: false })
  resetQuestionTab: ResetQuestionTabComponent;
  @ViewChild("changePasswordTab", { static: false })
  changePasswordTab: ChangePasswordTabComponent;
  @ViewChild("deleteTab", { static: false }) deleteTab: DeleteComponent;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const tab = (params.get("tab") as AccountTab) || "details";
      const tabs: Record<AccountTab, number> = {
        details: 1,
        contracts: 2,
        "invite-users": 3,
        "reset-question": 4,
        password: 5,
        delete: 6,
      };
      this.activetab = tabs[tab] || 1;
    });
  }

  get pageTitle(): string {
    switch (this.activetab) {
      case 2:
        return "Add Contracts";
      case 3:
        return "Invite Users";
      case 4:
        return "Update Reset Question";
      case 5:
        return "Change Password";
      case 6:
        return "Delete Account";
      default:
        return "Account Details";
    }
  }

  refresh(): void {
    switch (this.activetab) {
      case 2:
        this.addContractsTab?.ngOnInit();
        break;
      case 3:
        this.inviteUsersTab?.ngOnInit();
        break;
      case 4:
        this.resetQuestionTab?.ngOnInit();
        break;
      case 5:
        this.changePasswordTab?.ngOnInit();
        break;
      case 6:
        this.deleteTab?.resetMessage();
        break;
      default:
        this.accountDetailsTab?.ngOnInit();
        break;
    }
  }
}
